export enum components34Names {
    ROOM_LAYOUT = 'room-layout',
	HTML_NODE = 'html',
	FIELDS_SECTION = 'fields-section',
    MAP = 'map-location',
    RULES = 'inline-rules',
    TABS_SECTION = 'tabs-section',
    PHOTO_GALLERY = 'photo-gallery',
    PANORAMA_TOUR = '3d-tour',
    RESOURCE_MEDIA = 'resource-media-control',
    PHOTO_SELECTED = 'photo-selected',
    SMARTTAGS_LIST = 'smart-tags-list',
    SINGLE_IMAGE = 'single-image'
}
